import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBookmarkSvg } from "./IconBookmarkSvg.mjs";
const IconBookmark = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconBookmarkSvg, ...iconProps });
};
export {
  IconBookmark
};
